import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	OnInit,
	QueryList,
	ViewChildren,
} from '@angular/core';

import { tap } from 'rxjs/operators';

import { first, Observable } from 'rxjs';


import {
	PopUpComponentComponentRef,
	PopUpPosition,
	PopUpService,
} from 'ib/internetbank-core/ib-components';

import { LogData, UseractivityDataService } from '../../common/services/useractivity.data.service';

import { Story } from './models/stories.entities';
import { StoriesFacadeService } from './stories.facade.service';
import { StoryPopUpComponent } from './story-pop-up/story-pop-up.component';


@Component({
	selector: 'app-stories',
	templateUrl: './stories.component.html',
	styleUrls: ['./stories.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class StoriesComponent implements OnInit, AfterViewInit {


	@ViewChildren('story')
	public storyQueryList: QueryList<ElementRef<HTMLLIElement>>;

	public stories: Array<Story> = [];
	public stories$: Observable<Array<Story>>;

	constructor(
		private storiesFacadeService: StoriesFacadeService,
		private modalService: PopUpService,
		private useractivityDataService: UseractivityDataService,
	) { }


	public ngOnInit(): void {
		this.stories$ = this.storiesFacadeService.getList()
			.pipe(
				first(),
				tap((stories: Array<Story>) => this.stories = stories),
			);
	}

	public ngAfterViewInit(): void {


		const observer = new IntersectionObserver((entries: Array<IntersectionObserverEntry>) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) {

					this.useractivityDataService.log(
						new LogData(
							'STORY',
							'STORY_MAIN',
							'SHOW',
							[
								{
									param: 'story_Id',
									value: entry.target.attributes['story-id'].value,
								},
							],
						),
					)
						.subscribe();

					observer.unobserve(entry.target);
				}
			});
		},
			{threshold: 1, // Сработает, когда 100% элемента будет видно
			},
		);


		this.storyQueryList.changes
			.pipe(
				tap(() => {
					this.storyQueryList.forEach((item: ElementRef<HTMLElement>) => {
						observer.observe(item.nativeElement);
					});
				}),
			)
			.subscribe();

	}

	public handleStoryClick(id: number, index: number): void {

		const popupComponentRef: PopUpComponentComponentRef<StoryPopUpComponent> = this.modalService.open(
			StoryPopUpComponent,
			{
				position: PopUpPosition.FULLSCREEN,
				inputs: {
					storyIndex: index,
					stories: this.stories,
					closePopup: () => {
						popupComponentRef.componentRef.instance.close();
					},
				},
			},
			(componentInstance: StoryPopUpComponent) => { },
		);

		this.storiesFacadeService.markAsViewed(id);
	}


}
